// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"ra_a bih_sw bih_kx bih_ky","PostDetailRight__brandDaysPosts":"ra_b bih_sw bih_kx bih_ky"};